import React from 'react';
import styles from './index.module.scss';

function CommunityChallengeBanner({ isResolved, isChallengeWinner }) {
  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.bannerContent}>
        <span className={styles.bannerText}>
          {isResolved && isChallengeWinner ? 'challenge winner' : 'challenge entry'}
        </span>
        <img
          src='https://img.buzzfeed.com/store-an-image-prod-us-east-1/HTVmNVqal.png'
          alt="Banner Image"
          className={styles.bannerIcon}
        />
      </div>
    </div>
  )
}

export default CommunityChallengeBanner;
